module.exports = __webpack_public_path__ + "static/img/cp_02.18e3bd03.png";